module.exports = __webpack_public_path__ + "static/media/ron.0bfeb75c.jpg";